import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { ActivatedRoute } from '@angular/router';
import { SettingsHttpService } from '../../../../core/settings';
import { MixpanelService } from '../../../../services/mixpanel.service';
import { MachineRouteService } from '../machine-route.service';

@Component({
  selector: 'kt-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

	constructor(private mixpanelService: MixpanelService, private route: ActivatedRoute, private machineRouteService: MachineRouteService) { }

  ngOnInit() {
    const selectedMachine = this.machineRouteService.getMachine(this.route);
    if (selectedMachine) {
      this.mixpanelService.track(this.mixpanelService.PAGE_VIEW, { // Updated event name
        machine_id: selectedMachine.machine_id,
        machine_name: selectedMachine.machine_name,
        machine_serial_no: selectedMachine.serial_no
      });
    }
  }

}
